.kh{pointer-events:auto;}